import { FilterCardProps } from 'common/contracts';

import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';

import FilterControl from './FilterControl';

const FilterDropdownCard: React.FC<FilterCardProps> = ({
  header,
  filterValue,
  setFilterValue,
  isLabelSearchBy = false,
  options = []
}) => {
  const handleSelect = (selectedValue: string) => {
    setFilterValue(selectedValue);
  };

  const handleClear = () => {
    setFilterValue('');
  };

  const displayValue =
    options?.find((opt) => opt.value === filterValue)?.label || filterValue;

  return (
    <FilterControl
      header={header}
      filterValue={filterValue}
      displayValue={displayValue}
      onClear={handleClear}
      isLabelSearchBy={isLabelSearchBy}
    >
      {(close) => (
        <div className="p-3">
        <InputSelectDropdown
          label={header}
          options={options}
          defaultSelected={options?.find((opt) => opt.value === filterValue)}
          onOptionChange={(value) => {
            handleSelect(value);
            close();
          }}
        />
        </div>
      )}
    </FilterControl>
  );
};

export default FilterDropdownCard;
